import { render, staticRenderFns } from "./scSuccess.vue?vue&type=template&id=3bb48a23&"
import script from "./scSuccess.vue?vue&type=script&lang=js&"
export * from "./scSuccess.vue?vue&type=script&lang=js&"
import style0 from "./scSuccess.vue?vue&type=style&index=0&id=3bb48a23&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports